import { ClientTelerikReportPage } from "../components/ClientTelerikReportPage";
import { CLIENTS_ALL_ROLES } from "../../SharedModule/utils/constants";

export const ClientRelationshipUpdatesReportPage = () => (
  <ClientTelerikReportPage
    documentTitle="The Hub - Relationship Updates Report"
    reportTitle="Relationship Updates Report"
    reportName="ClientsKeyContactsRelationshipUpdates.trdp"
    allowedRoles={CLIENTS_ALL_ROLES}
    parametersAreaVisible={false}
  />
);
